import React, { ChangeEvent, useCallback, useMemo, useState } from "react";
import Button from "../Button";

export interface BuyProps {
  onClick: () => void;
}
const Buy = ({ onClick }) => {
  const [isConfirming, setIsConfirming] = useState(false);

  const [buttonBgColor, buttonTextColor] = useMemo(() => {
    if (isConfirming) {
      return ["bg-black", "text-white"];
    }

    return ["", ""];
  }, [isConfirming]);

  const onBuyClick = useCallback(() => {
    if (!isConfirming) {
      setIsConfirming(true);
      return;
    }
    setIsConfirming(false);
    onClick();
  }, [isConfirming]);

  return (
    <Button
      buttonClassName={buttonBgColor}
      textClassName={buttonTextColor}
      onClick={onBuyClick}
      label={!isConfirming ? "buy now" : "confirm buy"}
    />
  );
};

export default Buy;
